var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNatural(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 120,
    viewBox: "0 0 96 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 120C10.3 120 8.874 119.424 7.722 118.272C6.574 117.124 6 115.7 6 114C6 112.3 6.574 110.876 7.722 109.728C8.874 108.576 10.3 108 12 108H42V84H30C21.7 84 14.626 81.074 8.778 75.222C2.926 69.374 0 62.3 0 54C0 48 1.65 42.474 4.95 37.422C8.25 32.374 12.7 28.7 18.3 26.4C19.2 18.9 22.476 12.624 28.128 7.572C33.776 2.524 40.4 0 48 0C55.6 0 62.224 2.524 67.872 7.572C73.524 12.624 76.8 18.9 77.7 26.4C83.3 28.7 87.75 32.374 91.05 37.422C94.35 42.474 96 48 96 54C96 62.3 93.076 69.374 87.228 75.222C81.376 81.074 74.3 84 66 84H54V108H84C85.7 108 87.124 108.576 88.272 109.728C89.424 110.876 90 112.3 90 114C90 115.7 89.424 117.124 88.272 118.272C87.124 119.424 85.7 120 84 120H12Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNatural);
export default __webpack_public_path__ + "static/media/natural.6516e640dd9857eb8dda4df775262946.svg";
export { ForwardRef as ReactComponent };